import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=b53cb7aa&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"
import style0 from "./Register.vue?vue&type=style&index=0&id=b53cb7aa&prod&scoped=true&lang=css"
import style1 from "./Register.vue?vue&type=style&index=1&id=b53cb7aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b53cb7aa",
  null
  
)

export default component.exports